// extracted by mini-css-extract-plugin
module.exports = {"container":"AppMarquee_container__AWie_"};